/* Modulo Social Reviews — carousel nav only (dots + arrows).
   The rail swipes via native CSS scroll-snap with zero JS; this just builds
   one dot per card, wires the arrows, tracks the active dot proportionally,
   and disables the arrows at the ends. Entrance/hover motion is CSS-only.
   Vanilla IIFE, no deps, reduced-motion aware, re-inits in the theme editor. */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRail(rail) {
    if (!rail || rail.dataset.tsoReady === '1') return;
    var track = rail.querySelector('[data-tso-track]');
    if (!track) return;
    var cards = track.querySelectorAll('.modulo-tso__card');
    if (cards.length < 2) return;

    var prev = rail.querySelector('[data-tso-prev]');
    var next = rail.querySelector('[data-tso-next]');
    var dotsHost = rail.querySelector('[data-tso-dots]');
    if (!dotsHost) return;

    rail.dataset.tsoReady = '1';

    // build one dot per card
    var dots = [];
    var i;
    for (i = 0; i < cards.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to review ' + (i + 1));
      if (i === 0) b.className = 'is-active';
      (function (idx) {
        b.addEventListener('click', function () {
          var ms = maxScroll();
          track.scrollTo({ left: dots.length > 1 ? (idx / (dots.length - 1)) * ms : 0, behavior: REDUCE ? 'auto' : 'smooth' });
        });
      })(i);
      dotsHost.appendChild(b);
      dots.push(b);
    }

    function step() {
      var first = track.querySelector('.modulo-tso__card');
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 24;
      return (first ? first.offsetWidth : 0) + gap;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: REDUCE ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: REDUCE ? 'auto' : 'smooth' }); });

    var raf = 0;
    function sync() {
      var ms = maxScroll();
      var idx = ms > 0 ? Math.round((track.scrollLeft / ms) * (dots.length - 1)) : 0;
      if (idx < 0) idx = 0;
      if (idx > dots.length - 1) idx = dots.length - 1;
      for (var d = 0; d < dots.length; d++) {
        if (d === idx) dots[d].classList.add('is-active');
        else dots[d].classList.remove('is-active');
      }
      if (prev) prev.disabled = track.scrollLeft <= 6;
      if (next) next.disabled = track.scrollLeft >= ms - 6;
    }
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync);
    rail._tsoSync = sync;
    sync();
  }

  function boot() {
    var rails = document.querySelectorAll('[data-tso]');
    for (var i = 0; i < rails.length; i++) initRail(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // theme editor: re-init a re-rendered section
  document.addEventListener('shopify:section:load', function (e) {
    var rail = e.target && e.target.querySelector ? e.target.querySelector('[data-tso]') : null;
    if (rail) { rail.dataset.tsoReady = ''; initRail(rail); }
  });
})();
